import Token from './Token.js'
import Errors from './Errors.js'
import PersonCompanyIntroduction from './SubjectPeople/PersonCompanyIntroduction.js'
import PersonRegistration from './SubjectPeople/PersonRegistration.js'
import CustomerKYC from './SubjectPeople/CustomerKYC.js'
import PersonRegistrationBR from './SubjectPeople/PersonRegistrationBR.js'
import PersonRegistrationMX from './SubjectPeople/PersonRegistrationMX.js'
import PersonRegistrationCO from './SubjectPeople/PersonRegistrationCO.js'
import PersonRegistrationCL from './SubjectPeople/PersonRegistrationCL.js'
import PersonGenerals from './SubjectPeople/PersonGenerals.js'
import PersonsList from './SubjectPeople/PersonsList.js'
import PersonsListByID from './SubjectPeople/PersonsListByID.js'
import PersonTransactions from './SubjectPeople/PersonTransactions.js'
import PersonTotals from './SubjectPeople/PersonTotals.js'

import BankAccountsOverview from './BankAccount/BankAccountsOverview.js'
import BankAccountsRegistrationBR from './BankAccount/BankAccountsRegistrationBR'
import BankAccountsRegistrationMXN from './BankAccount/BankAccountsRegistrationMXN'
import BankAccountsRegistrationCO from './BankAccount/BankAccountsRegistrationCO.js'
import BankAccountsRegistrationCL from './BankAccount/BankAccountsRegistrationCL'
import BankAccountsRegistrationINT from './BankAccount/BankAccountsRegistrationINT'
import CustomerBankAccountsGenerals from './BankAccount/CustomerBankAccountsGenerals.js'
import CustomerBankAccountsListByID from './BankAccount/CustomerBankAccountsListByID'
import CustomerUpdateBankAccount from './BankAccount/CustomerUpdateBankAccount'

import InternalBankAccounts from './BankAccount/InternalBankAccounts'
import InternalBankAccountBalance from './BankAccount/InternalBankAccountBalance'
import InternalBankAccountStatement from './BankAccount/InternalBankAccountStatement'

import DocumentUpload from './Documents/DocumentUpload.js'

import CompaniesRegistration from './SubjectCompanies/CompaniesRegistration'
import CompaniesRegistrationBR from './SubjectCompanies/CompaniesRegistrationBR.js'
import CompaniesRegistrationMxn from './SubjectCompanies/CompaniesRegistrationMxn'
import CompaniesRegistrationCO from './SubjectCompanies/CompaniesRegistrationCO.js'
import CompaniesRegistrationCL from './SubjectCompanies/CompaniesRegistrationCL.js'
import CompaniesGenerals from './SubjectCompanies/CompaniesGenerals.js'
import CompaniesListByID from './SubjectCompanies/CompaniesListByID'
import CompaniesList from './SubjectCompanies/CompaniesList.js'

import TransactionsOverview from './Transaction/TransactionsOverview'
import TransactionDetails from './Transaction/TransactionDetails.js'
import TransactionStatusPayIn from './Transaction/TransactionStatusPayIn.js'
import TransactionStatusPayOut from './Transaction/TransactionStatusPayOut.js'
import TransactionsStatusExchange from './Transaction/TransactionsStatusExchange.js'
import TransactionsStatusSettlements from './Transaction/TransactionsStatusSettlements.js'
import TransactionBankAccountsIds from './Transaction/TransactionsBankAccountsIds.js'
import TransactionCreate from './Transaction/TransactionCreate.js'
import TransactionBrazil from './Transaction/TransactionBrazil.js'
import TransactionPix from './Transaction/TransactionPix.js'
import TransactionPixDynamic from './Transaction/TransactionPixDynamic'
import TransactionTED from './Transaction/TransactionTED.js'
import TransactionSpeiPayin from './Transaction/TransactionSpeiPayin.js'
import TransactionSpeiDynamicClabe from './Transaction/TransactionSpeiDynamicClabe.js'
import TransactionSpeiPayout from './Transaction/TransactionSpeiPayout.js'
import TransactionPayInExample from './Transaction/TransactionPayInExample.js'
import TransactionPayOutExemple from './Transaction/TransactionPayOutExemple.js'
import TransactionReverseExchange from './Transaction/TransactionReverseExchange.js'
import TransactionTransferBetweenInternalAccountsExample from './Transaction/TransactionTransferBetweenInternalAccountsExample.js'
import TransactionTransferBetweenInternalAccountsExampleUSD from './Transaction/TransactionTransferBetweenInternalAccountsExampleUSD.js'

import SubscriptionOverview from './Subscription/SubscriptionOverview.js'
import SubscriptionStatus from './Subscription/SubscriptionStatus.js'
import SubscriptionBRLCard from './Subscription/SubscriptionBRLCard.js'
import SubscriptionBRLCardConfirmation from './Subscription/SubscriptionBRLCardConfirmation.js'
import SubscriptionBRLAutomaticPix from './Subscription/SubscriptionBRLAutomaticPix.js'
import SubscriptionDetails from './Subscription/SubscriptionDetails.js'
import SubscriptionList from './Subscription/SubscriptionList.js'
import SubscriptionCancel from './Subscription/SubscriptionCancel.js'
import SubscriptionInvoicesList from './Subscription/SubscriptionInvoicesList.js'

import CreditCardRegistration from './Transaction/CreditCardRegistration'
import TransactionCreditCard from './Transaction/TransactionCreditCard'
import CreditCardBR from './Transaction/CreditCardBR.js'
import CreditCardBRJWTForDDC  from './Transaction/CreditCardBRJWTForDDC.js'
import CreditCardBRLCheckoutPage from './Transaction/CreditCardBRLCheckoutPage.js'
import CreditCardCOL from './Transaction/CreditCardCOL.js'
import CreditCardCOLConfirmation from './Transaction/CreditCardCOLConfirmation.js'
import CreditCardMX from './Transaction/CreditCardMX.js'
import CreditCardMXConfirmation from './Transaction/CreditCardMXConfirmation.js'
import CreditCardCHL from './Transaction/CreditCardCHL.js'
import CreditCardCHLConfirmation from './Transaction/CreditCardCHLConfirmation.js'
import TransactionBoleto from './Transaction/TransactionBoleto'
import TransactionBoletoGet from './Transaction/TransactionBoletoGet.js'
import TransactionPse from './Transaction/TransactionPse.js'
import TransactionPseBanks from './Transaction/TransactionPseBanks.js'
import TransactionLimits from './Transaction/TransactionLimits'
import RefundTransaction from './Transaction/RefundTransaction.js'
import RefundScheduledBankTransaction from './Transaction/RefundScheduledBankTransaction.js'
import RefundTransactionsList from './Transaction/RefundTransactionsList.js'

import TransactionsGenerals from './Transaction/TransactionsGenerals.js'
import TransactionsNotWiredList from './Transaction/TransactionsNotWiredList'

import BankTransfersWiresList from './Transaction/BankTransfersWiresList.js'
import BankTransferShow from './Transaction/BankTransferShow'
import BankTransfersTransactionsList from './Transaction/BankTransfersTransactionsList'

import ExchangeRates from './Exchange/ExchangeRates.js'
import TransactionConversionInternalAccount from './Transaction/TransactionConversionInternalAccount.js'
import TransactionConversionUnderRequest from './Transaction/TransactionConversionUnderRequest.js'
import TransactionConverionUnderConfirmExchange from './Transaction/TransactionConverionUnderConfirmExchange.js'
import TransactionSettlements from './Transaction/TransactionSettlements.js'
import TransactionSettlementsDepositFunding from './Transaction/TransactionSettlementsDepositFunding.js'
import ExchangeCalculate from './Exchange/ExchangeCalculate'

import WebhooksOverview from './WebHook/WebhooksOverview.js'
import EnableDisableWebhooks from './WebHook/EnableDisableWebhooks.js'
import DisableWebhooks from './WebHook/DisableWebhooks'
import NotificationWebhook from './WebHook/NotificationWebhook.js'
import SetNotificationSuccess from './WebHook/SetNotificationSuccess.js'
import WebhooksTransactions from './WebHook/WebhooksTransactions.js'
import WebhooksSubscriptions from './WebHook/WebhooksSubscriptions.js'
import NotificationSubscriptionCanceled from './WebHook/NotificationSubscriptionCanceled.js'
import NotificationSubscriptionCompleted from './WebHook/NotificationSubscriptionCompleted.js'
import NotificationSubscriptionInvoicePaid from './WebHook/NotificationSubscriptionInvoicePaid.js'
import NotificationSubscriptionInvoiceQRCodeGenerated from './WebHook/NotificationSubscriptionInvoiceQRCodeGenerated.js'
import NotificationExchange from './WebHook/NotificationExchange'
import NotificationWireCreated from './WebHook/NotificationWireCreated'
import NotificationCardTransactionApproved from './WebHook/NotificationCardTransactionApproved'
import NotificationCardTransactionReproved from './WebHook/NotificationCardTransactionReproved'
import WebhooksRelatedCustomer from './WebHook/WebhooksRelatedCustomer.js'
import WebhooksSubjectApproved from './WebHook/WebhooksSubjectApproved.js'
import WebhooksSubjectRejected from './WebHook/WebhooksSubjectRejected.js'
import NotificationDocumentRequired from './WebHook/NotificationDocumentRequired'
import WebhooksWireWaitingCorrection from './WebHook/WebhooksWireWaitingCorrection.js'
import WebhooksWireCorrection from './WebHook/WebhooksWireCorrection.js'
import WebhooksPaymentExpired from './WebHook/WebhooksPaymentExpired.js'
import NotificationPaymentRefund from './WebHook/NotificationPaymentRefund'
import TableOfContents from './Contents/TableOfContents'
import TransactionPayouts from './Transaction/TransactionPayouts.js'
import TransactionPSEPayout from './Transaction/TransactionPSEPayout.js'
import ApiAvailabilityStatusCode from './ApiAvailabilityStatusCode.js'
import MarketplaceOverview from './MarketplaceCollection/MarketplaceOverview.js'
import RequestingAuthorization from './MarketplaceCollection/RequestingAuthorization.js'
import RequestingBankAccounts from './MarketplaceCollection/RequestingBankAccounts.js'
import GettingBankAccountsAuthorized from './MarketplaceCollection/GettingBankAccountsAuthorized.js'

import DeprecatedCreditCardOverview from './Deprecated/Transaction/CreditCardOverview.js'
import DeprecatedCreditCardBR from './Deprecated/Transaction/CreditCardBR.js'
import DeprecatedCreditCardBRConfirmation from './Deprecated/Transaction/CreditCardBRConfirmation.js'


export default [
  Token,
  Errors,
  ApiAvailabilityStatusCode,

  //Person/Company Registration
  PersonCompanyIntroduction,
  PersonRegistration,
  PersonRegistrationBR,
  PersonRegistrationMX,
  PersonRegistrationCO,
  PersonRegistrationCL,
  PersonGenerals,
  PersonsListByID,
  PersonsList,
  CustomerKYC,
  PersonTransactions,
  PersonTotals,
  DocumentUpload,
  CompaniesRegistration,
  CompaniesRegistrationBR,
  CompaniesRegistrationMxn,
  CompaniesRegistrationCO,
  CompaniesRegistrationCL,
  CompaniesGenerals,
  CompaniesListByID,
  CompaniesList,

  //Real Bank Accounts
  BankAccountsOverview,
  BankAccountsRegistrationBR,
  BankAccountsRegistrationMXN,
  BankAccountsRegistrationCO,
  BankAccountsRegistrationCL,
  BankAccountsRegistrationINT,
  CustomerBankAccountsGenerals,
  CustomerBankAccountsListByID,
  CustomerUpdateBankAccount,

  //Internal Bank Accounts
  InternalBankAccounts,
  InternalBankAccountStatement,
  InternalBankAccountBalance,

  // General Transactions
  TransactionsOverview,
  TransactionBankAccountsIds,
  TransactionStatusPayIn,
  TransactionPayInExample,
  TransactionStatusPayOut,
  TransactionPayOutExemple,
  TransactionsStatusExchange,
  TransactionsStatusSettlements,
  TransactionCreate,
  ExchangeRates,
  TransactionConversionInternalAccount,
  TransactionConversionUnderRequest,
  TransactionConverionUnderConfirmExchange,
  TransactionTransferBetweenInternalAccountsExample,
  TransactionSettlements,
  TransactionSettlementsDepositFunding,
  TransactionTransferBetweenInternalAccountsExampleUSD,
  ExchangeCalculate,
  RefundTransaction,
  RefundScheduledBankTransaction,
  RefundTransactionsList,

  TransactionReverseExchange,
  TransactionsGenerals,
  TransactionsNotWiredList,
  TransactionDetails,
  TransactionLimits,
  BankTransfersWiresList,
  BankTransferShow,
  BankTransfersTransactionsList,

  // Subscriptions
  SubscriptionOverview,
  SubscriptionStatus,
  SubscriptionBRLCard,
  SubscriptionBRLCardConfirmation,
  SubscriptionBRLAutomaticPix,
  SubscriptionDetails,
  SubscriptionList,
  SubscriptionCancel,
  SubscriptionInvoicesList,

  //Card Transactions
  CreditCardRegistration,
  CreditCardBR,
  CreditCardBRJWTForDDC,
  CreditCardMX,
  CreditCardMXConfirmation,
  CreditCardCOL,
  CreditCardCOLConfirmation,
  CreditCardCHL,
  CreditCardCHLConfirmation,
  TransactionCreditCard,

  //Brazil Transactions
  TransactionBrazil,
  TransactionPix,
  TransactionPixDynamic,
  TransactionTED,
  TransactionBoleto,
  TransactionBoletoGet,
  CreditCardBRLCheckoutPage,
  TransactionPayouts,

  //Mexican Transactions
  TransactionSpeiPayin,
  TransactionSpeiDynamicClabe,
  TransactionSpeiPayout,

  //Colombian Transactions
  TransactionPse,
  TransactionPSEPayout,
  TransactionPseBanks,

  //Webhooks
  WebhooksOverview,
  EnableDisableWebhooks,
  DisableWebhooks,
  NotificationWebhook,
  SetNotificationSuccess,
  WebhooksTransactions,
  NotificationExchange,
  NotificationWireCreated,
  NotificationCardTransactionApproved,
  NotificationCardTransactionReproved,
  WebhooksWireWaitingCorrection,
  WebhooksWireCorrection,
  WebhooksSubscriptions,
  NotificationSubscriptionCanceled,
  NotificationSubscriptionCompleted,
  NotificationSubscriptionInvoicePaid,
  NotificationSubscriptionInvoiceQRCodeGenerated,
  WebhooksRelatedCustomer,
  WebhooksSubjectApproved,
  WebhooksSubjectRejected,
  NotificationPaymentRefund,
  NotificationDocumentRequired,
  WebhooksPaymentExpired,

  // MarketPlace Collection
  MarketplaceOverview,
  RequestingAuthorization,
  RequestingBankAccounts,
  GettingBankAccountsAuthorized,

  // Deprecated
  DeprecatedCreditCardOverview,
  DeprecatedCreditCardBR,
  DeprecatedCreditCardBRConfirmation,

  TableOfContents
]



// WEBPACK FOOTER //
// ./src/components/documentation/data/index.js